export const openAuthDialog = ({
  authType,
  trkLocation,
  onSuccessActions = () => {},
  onCleanUp = () => {},
  variantName = '',
}) => {
  window?.nwapi?.ui?.showAuthDialog({
    authType,
    version: 2,
    abTest: {
      variantName,
    },
    trk: {
      trk_location: trkLocation,
    },
    flowConfig: {
      errorToastPositionMobile: 'bottom-center',
    },
    onSuccess: () => {
      onSuccessActions();
    },
    onCleanUp,
  });
};
